import { useEffect } from "react";
import { trackEvent } from "../../../shared/lib/analytics";

const pendingKey = (userId) => `medhub:onboarding_pendente:${userId}`;

// Dispara "onboarding_concluido" uma vez, quando o checklist de quem já foi visto
// incompleto neste navegador passa a completo. A marca fica no localStorage (e não num
// ref) porque o caso comum é o médico concluir o último passo em outra tela e só depois
// voltar à Visão Geral, com este componente já desmontado. Quem já tinha concluído antes
// nunca foi visto incompleto e não gera evento.
export function useTrackOnboardingCompleted(userId, completed) {
  useEffect(() => {
    if (!userId || typeof completed !== "boolean") return;
    try {
      const key = pendingKey(userId);
      if (!completed) {
        window.localStorage.setItem(key, "1");
        return;
      }
      if (window.localStorage.getItem(key)) {
        window.localStorage.removeItem(key);
        trackEvent("onboarding_concluido");
      }
    } catch {
      // localStorage indisponível (modo privado restrito): medição não pode quebrar a tela.
    }
  }, [userId, completed]);
}
